<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>{{ message }}</div>
<div mat-dialog-actions align="end">
  <button mat-flat-button (click)="no()">{{ 'Generic.no' | translate }}</button>
  <button mat-flat-button (click)="yes()" color="primary">
    {{ 'Generic.yes' | translate }}
  </button>
</div>
